import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { HISTORICAL_URL } from 'app/@common/constants'


export default function SelectProvince({...props}) {

    const myProps = {
        urlAjax: HISTORICAL_URL.PROVINCE,
        placeholder: 'Province',
        icon: { icon: 'map-marker' },
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}